import { arkScope } from '@/api/workspace/endpoints/arkConfig.ts';
import type { CallOrder } from '@/store/orders/call/state.ts';

export const SavedCallOrderValidator = arkScope.type({
  type: '"CallOrder"',
  properties: {
    status: arkScope
      .type({ type: "'creating'" })
      .or({ type: "'pending'" })
      .or({ type: "'failed'", errorMessage: 'string' })
      .or({ type: "'submitted' | 'editing' | 'cancelled'", tradeId: 'string' }),
    'limitPrice?': 'number',
    'currencyPair?': {
      currency1: 'string',
      currency2: 'string',
      'tiering?': 'string',
    },
    expiry: arkScope
      .type({ type: '"GoodTillCancelled"' })
      .or({ type: '"ExpiryDate"', 'date?': 'string', 'time?': 'string' }),
    'notificationEmails?': 'string[]',
    isReadyToSubmit: 'boolean',
    'clockOffset?': 'number',
    mode: "'EDIT' | 'VIEW'",
  },
  tileId: 'string',
  'clientId?': 'number',
});

export type SavedCallOrder = typeof SavedCallOrderValidator.infer;

export const SavedCallOrder = {
  fromFxCallOrder: (fxTile: CallOrder, tileId: string): SavedCallOrder => ({
    type: 'CallOrder',
    properties: fxTile.properties,
    tileId,
    clientId: fxTile.clientId,
  }),
} as const;
